import React, { useState, useEffect, Fragment } from 'react'
import { useRecoilValue } from 'recoil'

// components
import { BottomButton, DatePicker, TextInput, Label, Breadcrumb } from 'components'

import { userInfoState } from 'store/atom/user-state-atom'
import { format } from 'date-fns'
import { useCustSfdgPsntInput, useCustSfdgPsntRegist } from 'api/shop/custsfdg-fetch'
import useModal from 'hook/useModal'
import { queryClient } from 'index'
import { getMessage } from 'utils/message-util'

function CustsfdgPsntReg({ date = new Date(), func = () => {} }) {
  const userInfo = useRecoilValue(userInfoState)
  const [today, setToday] = useState(date)

  console.log('선택일자 : ', today)

  const defaultParams = {
    siteId: userInfo.siteId,
    searchDt: format(today, 'yyyyMMdd'),
  }

  const { alertModal, confirmModal, closeModal, closeModalAll } = useModal()

  const [params, setParams] = useState(defaultParams)
  const [isInit, setIsInit] = useState(false)
  const [dataList, setDataList] = useState([])
  const { data, isSuccess } = useCustSfdgPsntInput(params, isInit)

  const custSfdgPsntRegist = useCustSfdgPsntRegist({
    successHandler: () => {
      alertModal(getMessage('common_msg_001', { status: '저장' }), () => {
        func()
        closeModalAll()
      })
    },
    errorHandler: () => {},
  })

  useEffect(() => {
    setIsInit(true)
    return () => queryClient.removeQueries('custSfdgPsntInput')
  }, [])

  useEffect(() => {
    if (data) {
      setDataList(() => data.data)
    }
  }, [data, isSuccess])

  const goRefresh = () => {
    setDataList(() => [])
    queryClient.removeQueries('custSfdgPsntInput')
    setIsInit(true)
  }

  const goRegist = () => {
    confirmModal('저장하시겠습니까?', () => {
      closeModal()
      custSfdgPsntRegist.mutate(dataList)
    })
  }

  return (
    <main>
      <div className="wrapper" style={{ marginBottom: '64px' }}>
        <div className="vertical-form mt16">
          <Label text="일자선택" />
          <DatePicker
            value={today}
            changeDate={(date) => {
              setToday(date)
              setParams((prev) => ({ ...prev, searchDt: format(date, 'yyyyMMdd') }))
              goRefresh()
            }}
          />
        </div>
        <span style={{ color: 'red' }}>※ 입력되는 값이 투표인원 입니다.</span>
        {dataList.map((item, index) => (
          <Fragment key={`regist_${index}`}>
            <div className="mt24">
              <Breadcrumb level="2" data={[item.mealNm, item.crnrNm, item.menuNm]} className="f-bold" />
            </div>
            <ul className="horizon-form-group mt8">
              <li>
                <Label className="" text="매우좋음" />
                <TextInput
                  type={'number'}
                  value={item.veryGoodCnt}
                  onChange={(e) => {
                    dataList[index].veryGoodCnt = e.target.value
                    setDataList(dataList.slice())
                  }}
                />
              </li>
              <li>
                <Label text="좋음" />{' '}
                <TextInput
                  type={'number'}
                  value={item.goodCnt}
                  onChange={(e) => {
                    dataList[index].goodCnt = e.target.value
                    setDataList(dataList.slice())
                  }}
                />
              </li>
              <li>
                <Label text="보통" />{' '}
                <TextInput
                  type={'number'}
                  value={item.normalCnt}
                  onChange={(e) => {
                    dataList[index].normalCnt = e.target.value
                    setDataList(dataList.slice())
                  }}
                />
              </li>
              <li>
                <Label text="나쁨" />{' '}
                <TextInput
                  type={'number'}
                  value={item.badCnt}
                  onChange={(e) => {
                    dataList[index].badCnt = e.target.value
                    setDataList(dataList.slice())
                  }}
                />
              </li>
              <li>
                <Label text="매우나쁨" />{' '}
                <TextInput
                  type={'number'}
                  value={item.veryBadCnt}
                  onChange={(e) => {
                    dataList[index].veryBadCnt = e.target.value
                    setDataList(dataList.slice())
                  }}
                />
              </li>
            </ul>
          </Fragment>
        ))}

        <BottomButton
          refresh={true}
          data={[{ title: '저장', color: 'primary' }]}
          onClick={goRegist}
          onRefresh={goRefresh}
        />
      </div>
    </main>
  )
}

export default CustsfdgPsntReg
